import { render, staticRenderFns } from "./set-permission-modal1.vue?vue&type=template&id=68cfa978"
import script from "./set-permission-modal1.vue?vue&type=script&lang=js"
export * from "./set-permission-modal1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports